import { LoanStatusType } from './LoanStatusType';

export const LoanStatusOptions = [
    { id: '', name: 'Loan Status...', shortName: 'Not Set' },
    {
        id: LoanStatusType.Approved,
        name: 'Approved (Not Closed)',
        shortName: 'Apprvd',
    },
    {
        id: LoanStatusType.Outstanding,
        name: 'Outstanding',
        shortName: 'Outstndg',
    },
    { id: LoanStatusType.Repaid, name: 'Repaid', shortName: 'Repaid' },
    { id: LoanStatusType.Deleted, name: 'Recycle Bin', shortName: 'Rcyld' },
    { id: LoanStatusType.Lost, name: 'Lost', shortName: 'Lost' },
];
